import { MigrationStatus } from "../generated/api-client";

export const migrationStatusValues: MigrationStatus[] = [
    "PersonPending",
    "UserPending",
    "Migrated",
    "IdpUserMissing",
    "Error",
];

export const migrationStatusLabels: Record<MigrationStatus, string> = {
    PersonPending: "Persona Pendiente",
    UserPending: "Usuario Pendiente",
    Migrated: "Migrado",
    IdpUserMissing: "Usuario IdP Faltante",
    Error: "Error",
};

export const migrationStatusOptions = migrationStatusValues.map(value => ({
    value,
    label: migrationStatusLabels[value],
}));
